import delegate from 'delegate-it';

class Expander {
  static defaultOptions = {
    togglerSelector: '[data-entity="toggler"]',
    shownClass: 'shown',
    hiddenClass: 'hidden',
    togglerTitleTag: null,
  };

  constructor(rootElement, options = {}) {
    this.rootElement = rootElement;
    this.options = {
      ...Expander.defaultOptions,
      ...options,
    };

    this.findElements();
    this.initConfig();
    this.initUiState();
    this.attachEvents();
  }

  findElements() {
    const { togglerTitleTag } = this.options;

    this.toggler = this.rootElement.querySelector(this.options.togglerSelector);
    this.togglerTitle = togglerTitleTag
      ? this.toggler.querySelector(togglerTitleTag) : this.toggler;
  }

  initConfig() {
    this.togglerDefaultValue = this.toggler.textContent;
    this.togglerExpandedValue = this.toggler.dataset.expandedValue || 'скрыть';
  }

  initUiState() {
    this.uiState = {
      listVisibility: 'hidden',
    };
  }

  attachEvents() {
    delegate(this.rootElement, this.options.togglerSelector, 'click', this.togglerClickHandler.bind(this));
  }

  togglerClickHandler() {
    this.uiState.listVisibility = this.uiState.listVisibility === 'hidden' ? 'shown' : 'hidden';

    this.renderRootElement();
    this.renderToggler();
  }

  renderRootElement() {
    const { listVisibility } = this.uiState;

    if (listVisibility === 'hidden') {
      this.rootElement.classList.add(this.options.hiddenClass);
      this.rootElement.classList.remove(this.options.shownClass);
    }

    if (listVisibility === 'shown') {
      this.rootElement.classList.add(this.options.shownClass);
      this.rootElement.classList.remove(this.options.hiddenClass);
    }
  }

  renderToggler() {
    const { listVisibility } = this.uiState;

    if (listVisibility === 'hidden') {
      this.togglerTitle.textContent = this.togglerDefaultValue;
    }

    if (listVisibility === 'shown') {
      this.togglerTitle.textContent = this.togglerExpandedValue;
    }
  }
}

export default Expander;
